module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "part-h"
  }, [_c('span', [_vm._v("THE CAVE")])]), _vm._v(" "), _c('p', {
    staticClass: "part-left1"
  }, [_c('i', [_vm._v("And they do not know the future mystery,")])]), _vm._v(" "), _c('p', {
    staticClass: "part-left2"
  }, [_c('i', [_vm._v("or understand ancient matters")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "part-left2"
  }, [_c('i', [_vm._v("And they do not know what is going to happen to them")]), _vm._v(",")]), _vm._v(" "), _c('p', {
    staticClass: "part-left2"
  }, [_c('i', [_vm._v("and they will not save their souls from the future mystery")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "part-left2a"
  }, [_vm._v("—"), _c('i', [_vm._v("The Dead Sea Scrolls")]), _vm._v(", prophecy of the Essenes")]), _vm._v(" "), _c('p', {
    staticClass: "part-left2"
  }, [_c('i', [_vm._v("Now has come the last age of the song of Cumae")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "part-left2"
  }, [_c('i', [_vm._v("From the renewed spirit of the Ages a new Order is born")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "part-left2"
  }, [_c('i', [_vm._v("Now the Virgin returns, the reign of Saturn returns")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "part-left2"
  }, [_c('i', [_vm._v("Now a new generation is sent down from heaven on high")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "part-left2a"
  }, [_vm._v("—"), _c('i', [_vm._v("Virgil, Fourth Eclogue")]), _vm._v(", messianic prophecy of the Sibyl")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a2b3892","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/part01.vue
// module id = 75
// module chunks = 0